registerComponent("sections/pj-cash", function (component) {
/**
 * Cash Management — sem comportamento próprio.
 *
 * A entrada escalonada e a pilha `sticky` são do `sections/produtos`.
 */

});
